import React, { ChangeEvent, SyntheticEvent, useEffect, useState } from "react";
import "./configurationDashboardNavbar.css"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
import {faEllipsisVertical} from "@fortawesome/free-solid-svg-icons";
import logo from '../../images/SALESCODE_LOGO.png'
import {ConfigurationDashboardOptions} from "../configurationDashboardOptions/configurationDashboardOptions";
import { NavbarConfigurationTypes } from "../configurationTypes/NavbarConfigurationTypes";
import { DashboardSelect } from "../Input/Input";
import { useTranslation } from 'react-i18next';
import { getMetaDataConfig, getNewConfiguration } from "../../services/uiConfigService";
import { configurationAttributeType, languageOptions } from "../../types";
import { defaultOptions } from "../../features/LanguageConfiguration/LanguageConfiguration";
import { Autocomplete, SelectChangeEvent, TextField } from "@mui/material";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { getConfigFromClientConfig } from "../../services/bannerServices";


export function ConfigurationDashboardNavbar() {
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const CUR_COMPONENT = "Navbar Options"
    const { translate } = usePortalTranslation();
    const { i18n } = useTranslation();
    const [languageOptions,setLanguageOptions] = useState<languageOptions[]>([]);
    const [showTranslation, setShowTranslation] = useState<boolean>(false);
    useEffect(() => {
        async function getAndSetLangaugeConfig(){
            const clientConfig = await getMetaDataConfig("clientconfig");
            const multilingualLanguageConfig = getConfigFromClientConfig(clientConfig,"multi_lingual_configuration");
            const languageConfig = getConfigFromClientConfig(clientConfig,"portal_configuration");
            if(multilingualLanguageConfig?.length){
                const availableLanguageOptions = (multilingualLanguageConfig.find((configObj: configurationAttributeType<languageOptions>) => {
                    return configObj.name === "supportedLanguages";
                })?.value ?? defaultOptions.supportedLanguages.value)  as languageOptions[] ;
                // const convertedLanguageOptions = availableLanguageOptions.map((languageObj) => {
                //     return {...languageObj,title: languageObj.language}
                // })
                setLanguageOptions(availableLanguageOptions);
            }
            if(languageConfig?.length){
                const languageConfigValue = languageConfig.find((configObj:any) => {
                    return configObj.name === "portalConfiguration";
                })?.value
                const translationConfig = languageConfigValue && languageConfigValue.find((item: { name: string; }) => item.name === "languageTranslation");
                setShowTranslation(translationConfig)
            }
        }
        getAndSetLangaugeConfig();
    },[])

    const handleClick = (event: any):void => {
        // i18next.changeLanguage("hi");
        setAnchorEl(event.currentTarget);
    }
    const handleClose = ():void => {
        setAnchorEl(null);
    }
    const handleLanguageChange = (event: SyntheticEvent,value: null | languageOptions) => { 
        if(value) i18n.changeLanguage(value.code)
    }
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const selectedLanguage = languageOptions.find((languageOption: languageOptions) => languageOption.code === i18n.language) ?? defaultOptions.supportedLanguages.value[0]
    return (
        <div className="configuration-navbar">
            <div className="navbar-logo-container">
                <img alt="logo" src={logo} style={{width:"80%"}}/>
            </div>
            <div className="configuration-types-container">
                <NavbarConfigurationTypes />
            </div>
            <div className="navbarMenu" style={showTranslation ? {width: "13%", marginLeft: "15px"} : {}}>
                {/* <div className="searchIcon">
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                </div> */}
                {showTranslation && <div className="searchIcon">
                    {/* <DashboardSelect size="small" onChange={handleLanguageChange} value={selectedLanguage} name="portalLanguage" options={languageOptions} selectLableId="portalLanguage" label="Language" /> */}
                    <div style={{width:"130px"}}>
                        <Autocomplete 
                        size="small"
                        onChange={handleLanguageChange}
                        disableClearable
                        getOptionLabel={(option) => translate(TranslationEnum.language,option.language)}
                        value={selectedLanguage}
                        options={languageOptions}
                        renderInput={(params) => <TextField  {...params} label={translate(TranslationEnum.navbar_options,"Language")} 
                        InputProps={{
                            ...params.InputProps,
                            style: { fontSize: '13px' } 
                        }} 
                        />}  
                    />
                    </div>
                    
                </div>}
                
                <div aria-describedby={id} onClick={handleClick} className="menuIcon" role="button"
  tabIndex={0}
  onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleClick(e);
    }
  }}>
                    <FontAwesomeIcon icon={faEllipsisVertical}/>
                </div>
                <ConfigurationDashboardOptions id={id} anchorEl={anchorEl} handleClose={handleClose} />
            </div>
        </div>
    );
}
